
export async function importPoiImage() {
    return await import(/* webpackChunkName: "poiImage" */ '@assets/images/poi_texture.png');
}

export async function importPointsImage() {
    return await import(/* webpackChunkName: "pointsImage" */ '@assets/images/points_texture.png');
}

export async function importSkyboxImage() {
    return await import(/* webpackChunkName: "skyboxImage" */ '@assets/images/skybox.png');
}

export async function importGpsPositionMarkerImage() {
    return await import(/* webpackChunkName: "gpsPositionMarkerImage" */ '@assets/images/gps_pos_marker.png');
}

export async function importGrassImage() {
    return await import(/* webpackChunkName: "grassImage" */ '@assets/images/environment/grass.png');
}

export async function importGrassNmImage() {
    return await import(/* webpackChunkName: "grassNmImage" */ '@assets/images/environment/grass-nm.png');
}

export async function importGrassInstance0Image() {
    return await import(/* webpackChunkName: "grassInstance0Image" */ '@assets/images/environment/grass-instance-0.png');
}

export async function importGrassInstance1Image() {
    return await import(/* webpackChunkName: "grassInstance1Image" */ '@assets/images/environment/grass-instance-1.png');
}

export async function importGrassInstance2Image() {
    return await import(/* webpackChunkName: "grassInstance2Image" */ '@assets/images/environment/grass-instance-2.png');
}

export async function importGrassInstance3Image() {
    return await import(/* webpackChunkName: "grassInstance3Image" */ '@assets/images/environment/grass-instance-3.png');
}

export async function importGeoCompassImage() {
    return await import(/* webpackChunkName: "geoCompassImage" */ '@assets/images/environment/geoCompass.png');
}

export async function importGeoCompassDarkImage() {
    return await import(/* webpackChunkName: "geoCompassDarkImage" */ '@assets/images/environment/geoCompass_dark.png');
}

export async function importGeoCompassInvertedImage() {
    return await import(/* webpackChunkName: "geoCompassInvertedImage" */ '@assets/images/environment/geoCompassInverted.png');
}

export async function importGeoCompassInvertedDarkImage() {
    return await import(/* webpackChunkName: "geoCompassInvertedDarkImage" */ '@assets/images/environment/geoCompassInverted_dark.png');
}

export async function importGeoCompassMinusImage() {
    return await import(/* webpackChunkName: "geoCompassMinusImage" */ '@assets/images/environment/geoCompassMinus.png');
}

export async function importGeoCompassMinusDarkImage() {
    return await import(/* webpackChunkName: "geoCompassMinusDarkImage" */ '@assets/images/environment/geoCompassMinus_dark.png');
}

export async function importGeoCompassPlusImage() {
    return await import(/* webpackChunkName: "geoCompassPlusImage" */ '@assets/images/environment/geoCompassPlus.png');
}

export async function importGeoCompassPlusDarkImage() {
    return await import(/* webpackChunkName: "geoCompassPlusDarkImage" */ '@assets/images/environment/geoCompassPlus_dark.png');
}
